import Specialty from './Specialty'
import { Model } from '@vuex-orm/core'

export class Rheumatology extends Specialty {
  static entity = 'rheumatology'
  static baseEntity = 'specialties'

  static fields() {
    return {
      ...super.fields()
    }
  }
}

export class ICD10Code extends Model {
  static entity = 'icd10code'

  static fields() {
    return {
      chapter: this.string(),
      section: this.string(),
      code: this.string(),
      long_description: this.string()
    }
  }
}
